module.exports = __webpack_public_path__ + "static/media/logo_min.bde4fd5b.svg";